import { InternalLinkInterface } from '@/types';

const InternalLinkBuilder = (
  internalLinkData: Partial<InternalLinkInterface>,
): InternalLinkInterface | undefined => {
  if (!internalLinkData?.slug?.current || !internalLinkData.language) return;

  const baseLink = {
    slug: { current: internalLinkData.slug.current },
    language: internalLinkData.language,
    _type: internalLinkData._type,
  };

  const pageParentSlug = internalLinkData.pageParent?.slug?.current;
  const grandParentSlug = internalLinkData.pageParent?.pageParent?.slug?.current;

  return pageParentSlug
    ? {
        ...baseLink,
        pageParent: {
          slug: { current: pageParentSlug },
          ...(grandParentSlug && {
            pageParent: {
              slug: { current: grandParentSlug },
            },
          }),
        },
      }
    : baseLink;
};

export default InternalLinkBuilder;
